import { render } from "./createConfigPublicAreaComponent.vue?vue&type=template&id=5f583b17&scoped=true"
import script from "./createConfigPublicAreaComponent.vue?vue&type=script&lang=js"
export * from "./createConfigPublicAreaComponent.vue?vue&type=script&lang=js"

import "./createConfigPublicAreaComponent.vue?vue&type=style&index=0&id=5f583b17&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f583b17"]])

export default __exports__